/**
 * Shared GlobalFilter props for client tag mapping and vendor tag mapping list pages.
 */
export const mappingListGlobalFilterProps = {
  columns: 3,
  defaultExpanded: false,
  expandOnApply: true,
  flexClassName: "flex flex-wrap md:flex-nowrap gap-2 items-center",
  containerClassName: "bg-white border rounded-lg mb-3",
};
